import getAdjChanges from '../helpers/getAdjChanges'
import hasTempId from '../helpers/hasTempId.js'
import store from '../store/index'
//--------------------
// process submission
//--------------------
export default function processSubmission({ changes = {}, original_adjs, character } = {}) {
  console.log('----------------------------------')
  console.log('IN processSubmission')
  /*
  Notes:
  - non-adj changes determined thru tracking changes in real-time as user edits fields
  - adj changes determined here using original_adjs (snapshot taken on initial load or after last save)
  */
  //--------------------
  // get change objects
  //--------------------
  const changed_profile = changes.profile ?? []
  const changed_chars = changes.chars ?? []
  const changed_skills = changes.skills ?? []
  const changed_runes = changes.runes ?? []
  const changed_items = changes.items ?? []
  const changed_counts = changes.counts ?? []
  const changed_spells = changes.spells ?? []
  const changed_armour_locations = changes.armour_locations ?? []
  const changed_campaign_notes = changes.campaign_notes ?? []
  //----------------------
  // declare change parms
  //----------------------
  // add character name/id for update confirmation msg (for all nested changes)
  let change_parms = {
    name: character.name,
    character_id: character.id,
    slug: character.slug || null,
  }

  //===================================
  // A. PROFILE CHANGES
  //===================================
  console.log('+++++++++++++++++++++++++++++++++++++++++++')
  console.log('A. PROCESSING ANY PROFILE CHANGES...')
  console.log('+++++++++++++++++++++++++++++++++++++++++++')
  //--------------------------------------------------------------------------------
  // NB: these changes have been captured in real-time as user edits profile fields
  //--------------------------------------------------------------------------------
  if (
    changed_profile &&
    changed_profile.payload &&
    Object.keys(changed_profile.payload).length > 0
  ) {
    //---------------------------------------------
    // ensure character name added (db name check)
    //---------------------------------------------
    if ('name' in changed_profile == false) {
      changed_profile.name = character.name
    }
    //------------------------------------------------------------------
    // ensure character slug added (for api call if existing character)
    //------------------------------------------------------------------
    if ('slug' in changed_profile == false) {
      changed_profile.slug = character.slug ? character.slug : null
    }
    //------------------------------
    // add changes profile to parms
    //------------------------------
    change_parms.changed_profile = changed_profile
    //
    console.log('===============================')
    console.log('changes PROFILE...')
    console.log('===============================')
    console.log('CHANGE PROFILE = ', changed_profile)
  } else {
    console.log('NO PROFILE CHANGES TO PROCESS...')
  }
  //===================================
  // B. CHARACTERISTIC CHANGES
  //===================================
  console.log('+++++++++++++++++++++++++++++++++++++++++++')
  console.log('B. PROCESSING ANY CHARACTERISTIC CHANGES...')
  console.log('+++++++++++++++++++++++++++++++++++++++++++')
  //-----------------------------------------------------------------------------------------------
  // NB: these changes have been captured in real-time as user edits chars fields (rolled/improvs)
  //-----------------------------------------------------------------------------------------------
  if (changed_chars && changed_chars.length > 0) {
    //---------------------------------------------------------------
    // NB: FOR NEW CHARACTERS: the initial characteristics will
    // be created in the backend. any changes from the race
    // defaults will be detected by track chars changes method.
    // these changes will be applied once the initial characteristic
    // records have been created in the backend.
    //---------------------------------------------------------------
    // NB: FOR EXISTING CHARACTERS: these changes will already
    // include the characteristic records ids.
    //---------------------------------------------------------------
    console.log('===============================')
    console.log('changes CHARS...')
    console.log('===============================')
    changed_chars.forEach((c) => {
      console.log('CHANGE CHAR = ', c)
    })
    //----------------------------
    // add changes chars to parms
    //----------------------------
    change_parms.changed_chars = changed_chars
  } else {
    console.log('NO CHARACTERISTIC CHANGES TO PROCESS...')
  }
  //===================================
  // C. SKILL CHANGES
  //===================================
  console.log('+++++++++++++++++++++++++++++++++++++++++++')
  console.log('C. PROCESSING ANY SKILL CHANGES...')
  console.log('+++++++++++++++++++++++++++++++++++++++++++')
  //------------------------------------------------------------
  // NB: these changes have been captured either:
  // a) in real-time as user edits ticks/training fields, OR
  // b) after each new skill (specialism) has been added
  //------------------------------------------------------------
  if (changed_skills && changed_skills.length > 0) {
    //----------------------------------------------------------
    // NB: FOR NEW CHARACTERS: the initial skills will
    // be created in the backend. any changes from the skill
    // defaults will be detected by track skill changes method.
    // these changes will be applied once the initial skill
    // records have been created in the backend.
    //----------------------------------------------------------
    // NB: FOR EXISTING SKILLS: these changes will already
    // include the skill records ids.
    //----------------------------------------------------------
    console.log('===============================')
    console.log('changes SKILLS...')
    console.log('===============================')
    changed_skills.forEach((c) => {
      console.log('CHANGE SKILL = ', c)
    })
    //----------------------------
    // add changes skills to parms
    //----------------------------
    if (changed_skills.length > 0) {
      change_parms.changed_skills = changed_skills
    }
  } else {
    console.log('NO SKILL CHANGES TO PROCESS...')
  }
  //===================================
  // D. ITEM CHANGES
  //===================================
  console.log('+++++++++++++++++++++++++++++++++++++++++++')
  console.log('D. PROCESSING ANY ITEM CHANGES...')
  console.log('+++++++++++++++++++++++++++++++++++++++++++')
  //------------------------------------------------------------
  // NB: these changes have been captured either:
  // a) in real-time as user edits fields thru a) itemcard or b) tableitems for item qty), OR
  // b) after each new item has been added
  //------------------------------------------------------------
  if (changed_items && changed_items.length > 0) {
    //----------------------------------------------------------
    // NB: FOR NEW CHARACTERS: the initial items will
    // be created in the backend. any changes from the item
    // defaults will be detected by track item changes method.
    // these changes will be applied once the initial item
    // records have been created in the backend.
    //----------------------------------------------------------
    // NB: FOR EXISTING ITEMS: these changes will already
    // include the item records ids.
    //----------------------------------------------------------
    console.log('===============================')
    console.log('changes ITEMS...')
    console.log('===============================')
    changed_items.forEach((c) => {
      console.log('CHANGE ITEM = ', c)
      //-----------------------------------------------------------------
      // if item linked to new container (temp id):
      // a) add container name (prefer display_name) for real id lookup
      // b) remove temp container id from payload
      //-----------------------------------------------------------------
      if (c.payload && 'container' in c.payload && hasTempId(c.payload.container)) {
        const containerItem = character.items.find((ci) => ci.id === c.payload.container)
        const containerName =
          (containerItem && containerItem.display_name) ||
          (containerItem && containerItem.name) ||
          null

        c.container_name = containerName
        delete c.payload.container
        console.log('setting container name to ', c.container_name, ' for item ', c.name)
      }

      //---------------------------------------------------------------------
      // if item linked to new attach_location (temp id):
      // a) add attach_location name (prefer display_name) for real id lookup
      // b) remove temp attach_location id from payload
      //---------------------------------------------------------------------
      if (c.payload && 'attach_location' in c.payload && hasTempId(c.payload.attach_location)) {
        const attachItem = character.items.find((ci) => ci.id === c.payload.attach_location)
        const attachName =
          (attachItem && attachItem.display_name) || (attachItem && attachItem.name) || null

        c.attach_location_name = attachName
        delete c.payload.attach_location
        console.log(
          'setting attach_location name to ',
          c.attach_location_name,
          ' for item ',
          c.name,
        )
      }

      //---------------------------------------------------------------------
      // where new artefact - add arena/campaign id for static item creation
      //---------------------------------------------------------------------
      if (c.type === 'Artefact' && c.action === 'ADD') {
        const activeArenaId = store?.state?.combat?.arena?.id ?? null
        c.payload.arena_id = character.arena || activeArenaId || null
        console.log('setting arena_id to ', c.payload.arena_id, ' for new artefact item ', c.name)
        //----------------------------------------------
        // augment payload with static Item fields for
        // artefacts whose static Item must be created
        // alongside the CharacterItem (composite flow)
        //----------------------------------------------
        // Prefer matching the in-memory item by temp character-item id
        // where available; fall back to matching by the static item
        // reference (ci.item) for artefacts created from free-text
        // entries where ids may not yet be aligned.
        let itemObj = null

        if (c.id !== null && c.id !== undefined) {
          itemObj = character.items.find((ci) => ci.id === c.id)
        }

        if (!itemObj && c.payload && c.payload.item) {
          itemObj = character.items.find((ci) => ci.item === c.payload.item && ci.type === c.type)
        }
        if (itemObj && itemObj.create_static_item) {
          c.payload.artefact_mode = 'CREATE_STATIC'
          // core Item attributes
          c.payload.item_name = itemObj.name
          c.payload.item_type = itemObj.type
          c.payload.artefact_type = itemObj.artefact_type ?? ''
          c.payload.trait = itemObj.trait ?? null
          c.payload.enc = itemObj.enc ?? 0
          // value/currency/race
          if (itemObj.value_lower != null) c.payload.value_lower = itemObj.value_lower
          if (itemObj.value_upper != null) c.payload.value_upper = itemObj.value_upper
          if (itemObj.currency != null) c.payload.currency = itemObj.currency
          if (itemObj.race != null) c.payload.race = itemObj.race
          c.payload.estimated_value =
            itemObj.estimated_value !== undefined
              ? itemObj.estimated_value
              : c.payload.estimated_value
          // descriptive fields
          if (itemObj.description) c.payload.description = itemObj.description
          if (itemObj.age) c.payload.age = itemObj.age
          if (itemObj.quality) c.payload.quality = itemObj.quality
          if (itemObj.material) c.payload.material = itemObj.material
          if (itemObj.artefact_base_item) c.payload.artefact_base_item = itemObj.artefact_base_item
          c.payload.countable = c.payload.countable ?? itemObj.countable ?? false
          c.payload.unit_name = c.payload.unit_name ?? itemObj.unit_name ?? null
          c.payload.max_unit_count = c.payload.max_unit_count ?? itemObj.max_unit_count ?? null
          c.payload.cur_unit_count = c.payload.cur_unit_count ?? itemObj.cur_unit_count ?? null
          c.payload.healing_type = itemObj.healing_type ?? null
          c.payload.recovers = itemObj.recovers ?? null
          c.payload.poison_type = itemObj.poison_type ?? null
          c.payload.pot = itemObj.pot ?? null
          c.payload.effect = itemObj.effect ?? null
          c.payload.delay = itemObj.delay ?? null
          c.payload.damage_dice = itemObj.damage_dice ?? null
          c.payload.duration = itemObj.duration ?? null
          c.payload.resist = itemObj.resist ?? null
          // ensure image_file present if captured on item object but
          // not yet in the change payload
          if (!c.payload.image_file && itemObj.image_file) {
            c.payload.image_file = itemObj.image_file
          }
        }
      }
    })
    //----------------------------
    // add changes items to parms
    //----------------------------
    change_parms.changed_items = changed_items
  } else {
    console.log('NO ITEM CHANGES TO PROCESS...')
  }
  //===================================
  // E. RUNE CHANGES
  //===================================
  console.log('+++++++++++++++++++++++++++++++++++++++++++')
  console.log('E. PROCESSING ANY RUNE CHANGES...')
  console.log('+++++++++++++++++++++++++++++++++++++++++++')
  //----------------------------------------------
  // NB: these changes have been captured either:
  // a) in real-time as user edits fields, OR
  // b) after each new rune has been added
  //-----------------------------------------------
  if (changed_runes && changed_runes.length > 0) {
    console.log('===============================')
    console.log('changes RUNES...')
    console.log('===============================')
    changed_runes.forEach((c) => {
      console.log('CHANGE RUNE = ', c)
      if (c && c.action === 'UPDATE' && Array.isArray(character.runes)) {
        const currentRune = character.runes.find((r) => r && r.id === c.id)

        if (currentRune) {
          c.full_payload = {
            character: currentRune.character ?? character.id ?? null,
            rune: currentRune.rune ?? null,
            strength: currentRune.strength ?? 0,
            pwr_storage: currentRune.pwr_storage ?? 0,
            starter: currentRune.starter ?? false,
            integrated: currentRune.integrated ?? false,
            active: currentRune.active ?? false,
            character_item: currentRune.character_item ?? null,
            notes: currentRune.notes ?? '',
          }
        }
      }

      //---------------------------------------------------------------------
      // if rune linked to new character item (temp id):
      // a) add character item name (prefer display_name) for real id lookup
      // b) remove temp character item id from payload
      //----------------------------------------------------------------------
      if (c.payload && 'character_item' in c.payload && hasTempId(c.payload.character_item)) {
        c.character_item_temp_id = c.payload.character_item
        const item = character.items.find((ci) => ci.id === c.payload.character_item)
        const itemName = (item && item.display_name) || (item && item.name) || null

        c.character_item_name = itemName
        delete c.payload.character_item
        if (c.full_payload) {
          delete c.full_payload.character_item
        }
        console.log('setting character item name to ', c.character_item_name, ' for rune ', c.name)
      }
    })
    //----------------------------
    // add changes runes to parms
    //----------------------------
    change_parms.changed_runes = changed_runes
  } else {
    console.log('NO RUNE CHANGES TO PROCESS...')
  }
  //===================================
  // F. SPELL CHANGES
  //===================================
  console.log('+++++++++++++++++++++++++++++++++++++++++++')
  console.log('F. PROCESSING ANY SPELL CHANGES...')
  console.log('+++++++++++++++++++++++++++++++++++++++++++')
  //----------------------------------------------
  // NB: these changes have been captured either:
  // a) in real-time as user edits fields, OR
  // b) after each new spell has been added
  //-----------------------------------------------
  if (changed_spells && changed_spells.length > 0) {
    console.log('===============================')
    console.log('changes SPELLS...')
    console.log('===============================')
    changed_spells.forEach((c) => {
      console.log('CHANGE SPELL = ', c)
      //---------------------------------------------------------------------
      // if spell linked to new character item (temp id):
      // a) add character item name (prefer display_name) for real id lookup
      // b) keep temp id in payload; it will be replaced with the
      //    real backend id later in useCharacterChangesHarness.
      //----------------------------------------------------------------------
      if (c.payload && 'character_item' in c.payload && hasTempId(c.payload.character_item)) {
        const item = character.items.find((ci) => ci.id === c.payload.character_item)
        const itemName = (item && item.display_name) || (item && item.name) || null

        c.character_item_name = itemName
        console.log('setting character item name to ', c.character_item_name, ' for spell ', c.name)
      }

      //---------------------------------------------------------------------
      // if spell linked to new character rune (temp id):
      // a) add character rune name for real id lookup
      // b) keep temp id in payload; it will be replaced with the
      //    real backend id later in useCharacterChangesHarness.
      //---------------------------------------------------------------------
      if (c.payload && 'character_rune' in c.payload && hasTempId(c.payload.character_rune)) {
        const rune =
          character.runes && character.runes.find((cr) => cr.id === c.payload.character_rune)
        const runeName = (rune && rune.display_name) || (rune && rune.name) || null

        c.character_rune_name = runeName
        console.log('setting character rune name to ', c.character_rune_name, ' for spell ', c.name)
      }
    })
    //----------------------------
    // add changes spells to parms
    //----------------------------
    change_parms.changed_spells = changed_spells
  } else {
    console.log('NO SPELL CHANGES TO PROCESS...')
  }
  //===================================
  // G. COUNT CHANGES
  //===================================
  console.log('+++++++++++++++++++++++++++++++++++++++++++')
  console.log('G. PROCESSING ANY COUNT CHANGES...')
  console.log('+++++++++++++++++++++++++++++++++++++++++++')
  //----------------------------------------------
  // NB: these changes have been captured either:
  // a) in real-time as user edits fields, OR
  // b) after each new count has been added
  //----------------------------------------------
  if (changed_counts && changed_counts.length > 0) {
    console.log('===============================')
    console.log('changes COUNTS...')
    console.log('===============================')
    //----------------------------
    // add changes counts to parms
    //----------------------------
    change_parms.changed_counts = changed_counts
  } else {
    console.log('NO COUNT CHANGES TO PROCESS...')
  }
  //===================================
  // H. CAMPAIGN NOTE CHANGES
  //===================================
  console.log('+++++++++++++++++++++++++++++++++++++++++++')
  console.log('H. PROCESSING ANY CAMPAIGN NOTE CHANGES...')
  console.log('+++++++++++++++++++++++++++++++++++++++++++')
  //----------------------------------------------
  // NB: these changes have been captured either:
  // a) in real-time as user edits fields, OR
  // b) after each new campaign note has been added
  //----------------------------------------------
  if (changed_campaign_notes && changed_campaign_notes.length > 0) {
    console.log('===============================')
    console.log('changes CAMPAIGN NOTES...')
    console.log('===============================')
    //----------------------------
    // add changes campaign notes to parms
    //----------------------------
    change_parms.changed_campaign_notes = changed_campaign_notes
  } else {
    console.log('NO CAMPAIGN NOTE CHANGES TO PROCESS...')
  }
  //===================================
  // I. ARMOUR LOCATION CHANGES
  //===================================
  console.log('+++++++++++++++++++++++++++++++++++++++++++')
  console.log('I. PROCESSING ANY ARMOUR LOCATION CHANGES...')
  console.log('+++++++++++++++++++++++++++++++++++++++++++')
  if (changed_armour_locations && changed_armour_locations.length > 0) {
    console.log('===============================')
    console.log('changes ARMOUR LOCATIONS...')
    console.log('===============================')
    change_parms.changed_armour_locations = changed_armour_locations
  } else {
    console.log('NO ARMOUR LOCATION CHANGES TO PROCESS...')
  }
  //===================================
  // J. ADJUSTMENT CHANGES
  //===================================
  console.log('+++++++++++++++++++++++++++++++++++++++++++')
  console.log('J. PROCESSING ANY ADJ CHANGES...')
  console.log('+++++++++++++++++++++++++++++++++++++++++++')
  //---------------------------------------------------------------------------
  // NB: any adj changes are identified now (there may be no changes).
  // each adj category (e.g. chars, abilities) is processed separately, but
  // the results are all added to a single changed_adjs array, which is passed
  // back to the parent view for processing.
  //---------------------------------------------------------------------------
  // declare adj categories
  //------------------------
  let adj_categories = ['characteristic', 'ability', 'characteristic-skill', 'skill']
  let changed_adjs = []
  console.log('>>>>>>> ORIGINAL ADJS = ', original_adjs)
  //----------------------------------------------------------------------
  // loop adj categories and gather changes where adjs exist/are editable
  //----------------------------------------------------------------------
  adj_categories.forEach((adj_category) => {
    console.log('>>>>>>>>>>>>>>>>> PROCESSING ADJ CATEGORY = ', adj_category)
    changed_adjs.push(
      ...getAdjChanges({
        category: adj_category,
        original_adjs: original_adjs.filter(
          (a) => a.category === adj_category && (a.editable === true || a.persistable === true),
        ),
        character: character,
      }),
    )
  })
  //-----------------------------------
  // check for pending skill deletions   (NB: not req'd for characteristics/abilities as fixed)
  //-----------------------------------
  let haveSkillDeletions = changed_skills.filter((s) => s.action === 'DELETE').map((s) => s.name)
  //-----------------------
  // got pending deletions
  //-----------------------
  if (haveSkillDeletions.length > 0) {
    console.log('PROCESSING SKILL DELETIONS - REMOVE ANY RELATED ADJ CHANGES...')
    console.log('Skills being deleted:', haveSkillDeletions)
    //-----------------------------------------------------------------------------------------------------------
    // remove any changed adjs where character now tagged for deletion (adjs will be deleted in bulk in backend)
    //-----------------------------------------------------------------------------------------------------------
    changed_adjs = changed_adjs.filter((adj) => {
      //-------------------------------------------------
      // check for matching skill name deletions <-> adj
      //-------------------------------------------------
      if (adj.category === 'skill' && haveSkillDeletions.includes(adj.name)) {
        console.log('REMOVING ADJ CHANGE FOR DELETED SKILL:', adj.name, 'action=', adj.action)
        return false // filter out this adj
      }
      return true // keep all other adjs
    })
  }
  console.log('===============================')
  console.log('changes ADJS = ', changed_adjs)
  console.log('===============================')
  //-------------------------------
  // add any changes adjs to parms
  //-------------------------------
  if (changed_adjs && changed_adjs.length > 0) {
    change_parms.changed_adjs = changed_adjs
  } else {
    console.log('NO ADJ CHANGES TO PROCESS...')
  }
  //=================================================
  // belt + braces check that changes added to parms
  //-------------------------------------------------
  if (Object.keys(change_parms).some((key) => key !== 'name')) {
    //---------------------
    // return change parms
    //---------------------
    return change_parms
  } else {
    return null
  }
}
